import { RequiresRegistration } from "lib-core"
export { RequiresRegistration }
export default RequiresRegistration
